export default __webpack_public_path__ + "static/media/aibanner.d4cae663.png";